import { TransactionType } from 'globals/types';
import { FsTransactionRowDataProps } from 'ui-elements/tables/FsTransactionsTable/FsTransactionRow/FsTransactionRow';
import { FsExpenditureTableCategoryRowProps } from 'ui-elements/tables/FsExpenditureTable/FsExpenditureTableCategoryRow/FsExpenditureTableCategoryRow';
import { FsTransactionRowWithBarGraphDataProps } from 'ui-elements/tables/FsTransactionRowsWithBarGraph/FsTransactionRowWithBarGraph/FsTransactionRowWithBarGraph';

export const getTransactions = (
  getTransactionArray: () => FsTransactionRowDataProps[],
  searchPhrase: string,
  type: string
): FsTransactionRowDataProps[] => {
  return getTransactionArray()
    .filter(({ name }) =>
      name.toLowerCase().includes(searchPhrase.toLowerCase())
    )
    .filter(
      ({ type: transactionType }) => transactionType === type || type === 'all'
    );
};

export const getCategories = (
  incomeCategories: () => FsExpenditureTableCategoryRowProps[],
  expenditureCategories: () => FsExpenditureTableCategoryRowProps[],
  type: string
): FsExpenditureTableCategoryRowProps[] => {
  switch (type) {
    case TransactionType.INCOME:
      return incomeCategories();
    case TransactionType.EXPENDITURE:
      return expenditureCategories();
    default:
      return [...incomeCategories(), ...expenditureCategories()];
  }
};

export const getRecurringTransactions = (
  incomesRows: () => FsTransactionRowWithBarGraphDataProps[],
  expendituresRows: () => FsTransactionRowWithBarGraphDataProps[],
  type: string
): FsTransactionRowWithBarGraphDataProps[] => {
  switch (type) {
    case TransactionType.INCOME:
      return incomesRows();
    case TransactionType.EXPENDITURE:
      return expendituresRows();
    default:
      return [...incomesRows(), ...expendituresRows()].map(
        ({ id, ...otherProps }, idx) => ({
          ...otherProps,
          id: idx,
        })
      );
  }
};
